var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h4", { staticClass: "mt-1" }, [
      _vm._v("\n        " + _vm._s(_vm.recoveryDetails.title) + "\n    "),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "bg-greige my-1 my-md-2 px-1" }, [
      _c("p", [_c("strong", [_vm._v(_vm._s(_vm.recoveryDetails.text))])]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "px-1" }, [
      _c(
        "div",
        { staticClass: "mb-1" },
        _vm._l(_vm.recoveryDetails.stepList, function (step, index) {
          return _c(
            "p",
            {
              key: "step-online-" + index,
              staticClass: "d-flex align-items-center mb-0",
            },
            [
              _c("span", {
                staticClass: "font-size-26",
                class: "icon-number-" + _vm.getIndex(index) + "-wired",
                attrs: { "aria-hidden": "true" },
              }),
              _vm._v(" "),
              _c("span", {
                staticClass: "ms-1",
                domProps: { innerHTML: _vm._s(step) },
              }),
            ]
          )
        }),
        0
      ),
      _vm._v(" "),
      _vm.recoveryDetails.documentLabel && _vm.recoveryDetails.documentList
        ? _c(
            "p",
            { staticClass: "mb-0" },
            [
              _c("span", [
                _c("strong", [
                  _vm._v(_vm._s(_vm.recoveryDetails.documentLabel)),
                ]),
              ]),
              _c("br"),
              _vm._v(" "),
              _c("ob1-liste-a-puces", {
                attrs: {
                  "liste-a-puces-dto": _vm.recoveryDetails.documentList,
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("p", { staticClass: "small mb-2" }, [
        _vm._v(
          "\n            " + _vm._s(_vm.recoveryDetails.mention) + "\n        "
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }